import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import RoutesConst from "@consts/RoutesConst";
import Homepage from "@pages/Homepage/Homepage";
import BlogPage from "@pages/BlogPage/BlogPage";
import ViewBlogPost from "@pages/BlogPage/ViewBlogPost";
import ProjectsPage from "@pages/ProjectsPage/ProjectsPage";
import FAQPage from "@pages/FAQPage/FAQPage";
import LoginPage from "@pages/LoginPage/LoginPage";
import FeatureFlagsConfig from "@config/feature-flags.json";

// The dashboard (and its TinyMCE-heavy blog editor) is only ever reached by signed-in staff,
// so it's split into its own chunk instead of shipping in the bundle anonymous site visitors
// download on their first request.
const Dashboard = lazy(() => import("@pages/Dashboard/Dashboard"));
const ArtistsPage = lazy(() => import("@pages/Dashboard/Artists/Artists"));
const Blog = lazy(() => import("@pages/Dashboard/Blog/Blog"));
const AddBlogPost = lazy(
  () => import("@pages/Dashboard/Blog/AddBlogPost/AddBlogPost")
);
const EditBlogPost = lazy(
  () => import("@pages/Dashboard/Blog/EditBlogPost/EditBlogPost")
);
const FAQs = lazy(() => import("@pages/Dashboard/FAQs/FAQs"));
const AccountSettings = lazy(
  () => import("@pages/Dashboard/AccountSettings/AccountSettings")
);
const ApiDocs = lazy(() => import("@pages/Dashboard/ApiDocs/ApiDocs"));
const DashboardFeatureFlags = lazy(
  () => import("@pages/Dashboard/DashboardFeatureFlags/DashboardFeatureFlags")
);
const Users = lazy(() => import("@pages/Dashboard/Users/Users"));
const HelpPage = lazy(() => import("@pages/Dashboard/Help/HelpPage"));

function App() {
  return (
    <Routes>
      {/* Site Routes */}
      <Route index path={RoutesConst.DEFAULT} element={<Homepage />} />
      <Route path={RoutesConst.BLOG.DEFAULT} element={<BlogPage />} />
      <Route path={RoutesConst.BLOG.VIEW_POST} element={<ViewBlogPost />} />
      {FeatureFlagsConfig.PROJECTS_PAGE && (
        <Route path={RoutesConst.PROJECTS} element={<ProjectsPage />} />
      )}
      <Route path={RoutesConst.FAQ} element={<FAQPage />} />
      <Route path={RoutesConst.LOGIN} element={<LoginPage />} />
      {/* Dashboard Routes */}
      <Route
        path={RoutesConst.DASHBOARD.DEFAULT}
        element={
          <Suspense fallback={null}>
            <Dashboard />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.API_DOCS}
        element={
          <Suspense fallback={null}>
            <ApiDocs />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.ACCOUNT_SETTINGS}
        element={
          <Suspense fallback={null}>
            <AccountSettings />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.ARTISTS}
        element={
          <Suspense fallback={null}>
            <ArtistsPage />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.BLOG.DEFAULT}
        element={
          <Suspense fallback={null}>
            <Blog />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.BLOG.ADD_POST}
        element={
          <Suspense fallback={null}>
            <AddBlogPost />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.BLOG.EDIT_POST}
        element={
          <Suspense fallback={null}>
            <EditBlogPost />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.FAQ}
        element={
          <Suspense fallback={null}>
            <FAQs />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.FEATURE_FLAGS}
        element={
          <Suspense fallback={null}>
            <DashboardFeatureFlags />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.USERS}
        element={
          <Suspense fallback={null}>
            <Users />
          </Suspense>
        }
      />
      <Route
        path={RoutesConst.DASHBOARD.HELP}
        element={
          <Suspense fallback={null}>
            <HelpPage />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default App;
